import UserProfileCard from "./Components/UserProfileCard/UserProfileCard";
import './App.css';

function App() {
  return (
    <div className="App">
      <UserProfileCard />
    </div>
  );
}

export default App;